define('community-blog',['controller', 'blog-editor'],
function(controller, editor) {
	controller.on(['community/blog/add', 'community/blog/edit'], function() {
		editor.initMCE('#blog-post-text-input');
		$(".select").select2({
		    minimumResultsForSearch: -1,
		    width: "100%"
		});
	});
});

